import $ from 'jquery';
import screenSize from './../../../common/screen_size_util';

/* this module affects the category list styling and movement on the annual homepage */

module.exports = function () {
    var viewport = screenSize.getSize();
    var container= $('.mic-list-companies__past-years');
    var evenOdd= $('.mic-list-companies__past-years').length;

    function isEven(n) {
       return n % 2 == 0;
    }

    if (viewport === 'xxlarge' || viewport === 'xlarge') {
        $(container).slice(0, 2).css({
            'padding-top': '0px',
            'margin-top': '12px'
        });
    }

    if (viewport === 'large' || viewport === 'medium') {
        $(container).slice(0, 2).css({
            'padding-top': '0px',
            'margin-top': '12px'
        });
        if(isEven(evenOdd)){
            $(container).slice(-2).addClass('mic-list-companies__no-border');
        } else {
             $(container).slice(-2).addClass('mic-list-companies__no-border');
             $('.mic-list-companies__past-years--placeholder').addClass('mic-list-companies__no-border');
        }

    }

    if (viewport === 'small') {
        if(isEven(evenOdd)){
           $(container).slice(-1).css('display', 'none');
           $(container).slice(-2).addClass('mic-list-companies__no-border');
           $(container).slice(-2).css('padding-bottom', '18px');
        }

        $(container).slice(0, 1).css('padding-top', '12px');
        $(container).slice(-1).addClass('mic-list-companies__no-border');
    }

};
